import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { REQUIRED_MESSAGE } from "../../../constants";
import FormEndowmentDelivery from "./formEndowmentDelivery";
import { getMaestras } from "../../../actions/generation-contarct-action";
import { styleEndowment } from "../styleEndowment";
import ModalConfirmBase from "../../../utils/form/modalConfirmBase";
import { getContractByDocument } from "../../../actions/endowment-delivery-action";
import { useStateValue } from "../../../context/store";
import NextGenerateEndowment from "./nextGenerateEndowment";

const GenerateEndowmentDelivery = () => {
  const classes = styleEndowment();
  const [{}, dispatch] = useStateValue();
  const [validNumber, setValidNumber] = useState(false);
  const [maestras, setMaestras] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isNextForm, setIsNextForm] = useState(false);
  const [dataContract, setDataContract] = useState({});

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    title: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Entrega de dotación",
      breadCrumbSubText: "Entrega de dotación",
      index: 32,
    });
  }, [dispatch]);

  const schema = yup.object().shape({
    documentType: yup.string().required(REQUIRED_MESSAGE),
    document: validNumber
      ? yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9A-Za-zÑñ]{0,16})$/,
            "Ingrese un número de identificación válido"
          )
      : yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9]{0,16})$/,
            "Ingrese un número de identificación válido"
          ),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    initialStateForm: { documentType: "", document: "" },
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    const getDataMaestras = async () => {
      const resp = await getMaestras();
      setMaestras(resp?.data?.maestras?.tipoDocumnetoIdentificacion);
    };
    getDataMaestras();
  }, []);

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const messageRequest = (msj) => {
    setMessage({
      description: msj,
      textButtonSubmit: "ACEPTAR",
      handleClick: () => handleClickClose(),
      oneButtons: true,
      type: "WARNING",
      open: true,
    });
  };

  const onSubmit = async (data) => {
    const response = await getContractByDocument(
      data.document,
      data.documentType
    );
    if (response?.status === 200 || response?.status === 201) {
      setDataContract(response?.data);
      setIsDisabled(true);
      setIsNextForm(true);
    } else {
      const msj =
        "El usuario ingresado no cuenta con un contrato activo, no se le puede generar entrega de dotación";
      messageRequest(msj);
      setIsDisabled(false);
      setIsNextForm(false);
    }
  };

  const validateTypeDocumentPastport = watch("documentType") === "PP";
  const validateTypeDocumentForeigner = watch("documentType") === "CE";

  useEffect(() => {
    if (validateTypeDocumentPastport || validateTypeDocumentForeigner) {
      setValidNumber(true);
    } else {
      setValidNumber(false);
    }
  }, [validateTypeDocumentPastport, validateTypeDocumentForeigner]);

  return (
    <div className={classes.containerForm}>
      <FormEndowmentDelivery
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        errors={errors}
        control={control}
        register={register}
        dataMaestras={maestras}
        getValues={getValues}
        isDisabled={isDisabled}
      />

      {isNextForm && (
        <NextGenerateEndowment
          dataContract={dataContract}
          message={message}
          setMessage={setMessage}
        />
      )}

      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        title={message.title}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default GenerateEndowmentDelivery;
